import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("het_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#262626]" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-[#F9F6F0] rounded-lg p-8 md:p-10">
        <div className="w-12 h-12 rounded-full bg-[#D32F2F]/10 flex items-center justify-center mb-6"><Lock className="w-6 h-6 text-[#D32F2F]" /></div>
        <h1 className="font-display font-black text-3xl text-[#262626]">Admin Login</h1>
        <p className="text-[#262626]/60 mt-2 text-sm">Manage products for Hometown Era Cards.</p>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <label className="block text-sm font-bold text-[#262626] mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="w-full rounded-md border border-[#262626]/20 px-4 py-3 bg-white focus:ring-2 focus:ring-[#D32F2F] focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-bold text-[#262626] mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="w-full rounded-md border border-[#262626]/20 px-4 py-3 bg-white focus:ring-2 focus:ring-[#D32F2F] focus:outline-none" />
          </div>
          {error && <p className="text-sm text-[#D32F2F] font-semibold" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-[#D32F2F] text-white font-bold py-3.5 rounded-md hover:bg-[#B71C1C] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
